// Navigation and URL handling module

export class NavigationManager {
  constructor() {
    this.initSmoothScrolling();
    this.initPopstateHandler();
    this.handleInitialLoad();
  }

  private initSmoothScrolling(): void {
    document
      .querySelectorAll<HTMLAnchorElement>('a[href^="#"]')
      .forEach((anchor) => {
        anchor.addEventListener("click", (e: Event) => {
          e.preventDefault();
          const targetSelector = anchor.getAttribute("href");
          if (targetSelector) {
            this.handleNavigation(targetSelector);
          }
        });
      });
  }

  private handleNavigation(targetSelector: string): void {
    // Check if there are URL parameters in the href
    const [selector, params] = targetSelector.split("?");
    const target = document.querySelector(selector);

    if (target) {
      // Update URL in browser history
      const newUrl = params ? `${selector}?${params}` : selector;
      const fullUrl = `${window.location.pathname}${window.location.search}${newUrl}`;
      window.history.pushState(
        { section: selector, params: params },
        "",
        fullUrl
      );

      target.scrollIntoView({ behavior: "smooth" });

      // Handle URL parameters for form pre-filling
      if (params) {
        // Emit custom event for form module to handle
        window.dispatchEvent(
          new CustomEvent("navigation:urlParams", {
            detail: { params },
          })
        );
      }
    }
  }

  private initPopstateHandler(): void {
    window.addEventListener("popstate", (event) => {
      if (event.state && event.state.section) {
        const target = document.querySelector(event.state.section);
        if (target) {
          target.scrollIntoView({ behavior: "smooth" });

          // Handle URL parameters for form pre-filling
          if (event.state.params) {
            window.dispatchEvent(
              new CustomEvent("navigation:urlParams", {
                detail: { params: event.state.params },
              })
            );
          }
        }
      }
    });
  }

  private handleInitialLoad(): void {
    document.addEventListener("DOMContentLoaded", () => {
      // Check for hash with parameters (e.g., #waitlist?attendee_count=2)
      const hash = window.location.hash;
      if (hash && hash.includes("?")) {
        const [selector, params] = hash.split("?");
        const target = document.querySelector(selector);
        if (target && params) {
          // Scroll to section and handle params on initial load with hash parameters
          target.scrollIntoView({ behavior: "smooth" });
          window.dispatchEvent(
            new CustomEvent("navigation:urlParams", {
              detail: { params },
            })
          );
        }
      }

      // Also check traditional search parameters
      const urlParams = new URLSearchParams(window.location.search);
      const attendeeCount = urlParams.get("attendee_count");

      if (attendeeCount) {
        window.dispatchEvent(
          new CustomEvent("navigation:urlParams", {
            detail: { params: `attendee_count=${attendeeCount}` },
          })
        );
      }
    });
  }
}
